import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MediosComponent} from "../../medios.component";
import {TransmediaService} from "../../../../../../core/services/parameters/transmedia.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-operation.component.html',
  styleUrls: ['./confirm-delete-operation.component.scss']
})
export class ConfirmDeleteOperationComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<MediosComponent>,
    private transmediaService: TransmediaService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.transmediaService.deleteTransmedia(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      })
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
